import { DataGridFilters } from "fe-shared/src/components/DataGrid/modules/types";
import { TransactionType } from "fe-shared/src/types/domain";
import {
  ADJUSTABLE_SUBMITTED_STATUS,
} from "fe-shared-transactions/src/helpers/transactionsGridConfig";
import { TransactionStatus } from "fe-shared-transactions/src/types";

const PICTUS_EXPORT_STATUSES = [
  TransactionStatus.InReview,
  TransactionStatus.Reviewed,
  ADJUSTABLE_SUBMITTED_STATUS,
  TransactionStatus.Submitted,
  TransactionStatus.Approved,
];

export const isPictusJsonExportAvailable = (
  hasExportPermission: boolean,
  isExportEnabled: boolean,
  filters: DataGridFilters
) => {
  const transactionTypes = filters.transactionType?.value;
  const hasSupportedTransactionType =
    Array.isArray(transactionTypes) &&
    transactionTypes.length === 1 &&
    (transactionTypes[0] === TransactionType.Receipt ||
      transactionTypes[0] === TransactionType.Delivery);
  const statusCode = filters.statusCode?.value;
  const hasExportableStatus =
    typeof statusCode === "string" && PICTUS_EXPORT_STATUSES.includes(statusCode);

  return (
    hasExportPermission &&
    isExportEnabled &&
    hasSupportedTransactionType &&
    hasExportableStatus
  );
};
